import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { provideTranslocoScope, TranslocoModule } from '@jsverse/transloco';
import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { environment } from 'environments/environment';

export interface ReactivateDialogResult {
    initials: string;
    password: string;
}

@Component({
    selector: 'app-reactivate-dialog',
    standalone: true,
    templateUrl: './reactivate-dialog.component.html',
    styleUrls: ['./reactivate-dialog.component.scss'],
    imports: [
        MatDialogModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        FormsModule,
        TranslocoModule,
        CdkDrag,
        CdkDragHandle,
    ],
    providers: [provideTranslocoScope('codext')],
})
export class ReactivateDialogComponent {
    initials = environment.loginInitials ?? '';
    password = environment.loginPassword ?? '';

    constructor(private dialogRef: MatDialogRef<ReactivateDialogComponent>) {}

    onConfirm() {
        this.dialogRef.close({ initials: this.initials, password: this.password } as ReactivateDialogResult);
    }
}
